import * as React from "react";
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import MuiToolbar from "@mui/material/Toolbar";
import { tabsClasses } from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import SideMenuMobile from "./SideMenuMobile";
import MenuButton from "./MenuButton";

const Toolbar = styled(MuiToolbar)({
  width: "100%",
  padding: "16px",
  height: '32px',
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "center",
  gap: "12px",
  flexShrink: 0,
  [`& ${tabsClasses.flexContainer}`]: {
    gap: "8px",
    p: "8px",
    pb: 0,
  },
});

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: "auto", md: "none" },
        boxShadow: 0,
        bgcolor: "#FFD300",
        backgroundImage: "none",
        borderBottom: "1px solid",
        borderColor: "divider",
        top: "var(--template-frame-height, 0px)",
        height: "64px"
      }}
    >
      <Toolbar variant="regular" sx={{height: "64px"}}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            flexGrow: 1,
            width: "100%",
            gap: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: "center", mr: "auto" }}
          >
            <CustomIcon />
            <Typography
              variant="h4"
              component="h1"
              sx={{ color: "text.primary" }}
            >
              
            </Typography>
          </Stack>
          <MenuButton aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuRoundedIcon sx={{fontSize: '30px', color: '#00081C'}} />
          </MenuButton>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export function CustomIcon() {
  return (
    <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDcwIDQ4IiBmaWxsPSJub25lIj48cGF0aCBkPSJNNjguMjUxOSAwSDU3LjM3ODlDNTYuODc1OCAwIDU2LjQxMjEgMC4yNzk1NTQgNTYuMTY2OCAwLjczMDcxM0wzOC4wMTY4IDM0LjE3MzdWMC45NDkzNzJDMzguMDE2OCAwLjQyNTMyNyAzNy42MDI1IDAgMzcuMDkyMiAwSDI2LjIxOTJDMjUuNzE2IDAgMjUuMjUyNCAwLjI3OTU1NCAyNS4wMDcxIDAuNzMwNzEzTDAuMTE4MTUxIDQ2LjU4ODRDLTAuMjI1MDgzIDQ3LjIyMTMgMC4yMjA1ODEgNDggMC45MjU5MTggNDhIOS40Mzg0OUM5Ljk0NjE1IDQ4IDEwLjQxMzQgNDcuNzE0OSAxMC42NTY5IDQ3LjI1NzNMMTUuMDE2NSAzOS4wNDE0SDI3LjcwOTlWNDcuMDUwNkMyNy43MDk5IDQ3LjU3NDcgMjguMTI0MSA0OCAyOC42MzQ0IDQ4SDQwLjU5OTFDNDEuMTA2OCA0OCA0MS41NzQgNDcuNzE0OSA0MS44MTc1IDQ3LjI1NzNMNDYuMTc3MSAzOS4wNDE0SDU4Ljg3MDVWNDcuMDUwNkM1OC44NzA1IDQ3LjU3NDcgNTkuMjg0NyA0OCA1OS43OTUgNDhINjguMjUxOUM2OC43NjIzIDQ4IDY5LjE3NjUgNDcuNTc0NyA2OS4xNzY1IDQ3LjA1MDZWMC45NDkzNzJDNjkuMTc2NSAwLjQyNTMyNyA2OC43NjIzIDAgNjguMjUxOSAwWk0yNy43MDk5IDI5LjI3OTJIMjAuMTk2NEwyNy4yNzUgMTUuOTM4MkMyNy4zOSAxNS43MjIzIDI3LjcwOSAxNS44MDUzIDI3LjcwOSAxNi4wNTE3TDI3LjcwOTkgMjkuMjc5MlpNNTguODY5NiAyOS4yNzkySDUxLjM1NjJMNTguNDM0NyAxNS45MzgyQzU4LjU0OTcgMTUuNzIyMyA1OC44Njg3IDE1LjgwNTMgNTguODY4NyAxNi4wNTE3TDU4Ljg2OTYgMjkuMjc5MloiIGZpbGw9IiMwMDA4MUMiPjwvcGF0aD48L3N2Zz4=" alt="logo" style={{ width: "48px", marginTop: '3px' }} />
  );
}
